import { useSelector } from 'react-redux';

const useGetSummaryDetails = () => ({
  forename: useSelector((state) => state.ApplicantData.forename),
  surname: useSelector((state) => state.ApplicantData.surname),
  categories: {
    renewCategories: useSelector((state) => state.SelectedCategoriesData.renewCategories),
    selectedCategories: useSelector((state) => state.SelectedCategoriesData.selectedCategories),
  },
  mailingAddress: {
    useHomeAddress: useSelector((state) => state.MailingAddressData.useHomeAddress),
    mailingAddressLine1: useSelector((state) => state.MailingAddressData.mailingAddressLine1),
    mailingAddressLine2: useSelector((state) => state.MailingAddressData.mailingAddressLine2),
    mailingAddressLine3: useSelector((state) => state.MailingAddressData.mailingAddressLine3),
    mailingAddressLine4: useSelector((state) => state.MailingAddressData.mailingAddressLine4),
    mailingPostcode: useSelector((state) => state.MailingAddressData.mailingPostcode),
  },
});

export default useGetSummaryDetails;
